/**
 * Funcion que retorna la expresion regular para validar la cantidad de enteros y decimales permitidos de un numero
 * @param int integer Cantidad de enteros
 * @param int decimal Cantidad de decimales
 */
export const regexpRuleNumber = () => {
  return /^\d{0,18}(\.\d{0,5})?$/;
}
